module.exports = __webpack_public_path__ + "img/devOps-focus.e263f657.png";